import React from 'react';
import get from 'lodash/get';
import has from 'lodash/has';
import * as PropTypes from 'prop-types';

import Chips from '@components/shared/Chips';
import Link from '@components/shared/Link';
import routes from '@constants/routes';

const ProfileInfo = ({ details, isEditable }) => {
  const params = [
    {
      title: 'Conditions',
      list: details.disease_conditions,
      getLabel: c => c.name
    },
    {
      title: 'Supplements',
      list: details.supplements,
      emptyMessage: 'Add supplements you’re currently taking',
      getLabel: c => c.name
    },
    {
      title: 'Diet',
      list: details.diets,
      emptyMessage: 'Add diets that you follow',
      getLabel: c => c.name
    },
    {
      title: 'Symptoms',
      list: details.symptoms,
      emptyMessage: 'Add your symptoms',
      getLabel: c => c.name
    },
    {
      title: 'Medicine',
      list: details.medicine,
      emptyMessage: 'Add medicine you’re currently taking',
      getLabel: c => (c.name ? c.name : c)
    },
    {
      title: 'Products',
      list: details.products,
      emptyMessage: 'Add any helpful products you use',
      getLabel: c => c.name
    },
    {
      title: 'About',
      emptyMessage: 'Introduce yourself to the CureRate community!',
      // eslint-disable-next-line react/display-name
      render: () =>
        details.description ? (
          <div className="chips" key="about">
            <p className="chips__title">About</p>
            <div className="chips__list">
              <div style={{ wordBreak: 'break-word' }}>
                {details.description}
              </div>
            </div>
          </div>
        ) : null
    }
  ];

  return (
    <div className="profile-info">
      {isEditable && (
        <Link
          href={routes.profile.edit}
          className="profile-info__edit-btn"
          icon="edit"
        >
          Add info
        </Link>
      )}

      {isEditable &&
        params.map(param => {
          if (param.render) {
            return (
              param.render() || (
                <div className="chips" key="about">
                  <p className="chips__title">About</p>
                  <div className="chips__empty">
                    {param.emptyMessage ? param.emptyMessage : `No info added`}
                  </div>
                </div>
              )
            );
          }

          return (
            <Chips
              className="profile-info__chips"
              key={param.title}
              title={param.title}
              array={param.list}
              getChipLabel={param.getLabel}
              emptyMessage={
                param.emptyMessage ? param.emptyMessage : `No info added`
              }
            />
          );
        })}

      {!isEditable &&
        params
          .filter(p => get(p, 'list.length') || has(p, 'render'))
          .map(param =>
            param.render ? (
              param.render()
            ) : (
              <Chips
                className="profile-info__chips"
                key={param.title}
                title={param.title}
                array={param.list}
                getChipLabel={param.getLabel}
              />
            )
          )}
    </div>
  );
};

ProfileInfo.propTypes = {
  details: PropTypes.any,
  isEditable: PropTypes.bool
};

export default ProfileInfo;
